export default "__VITE_ASSET__mJMVLijz__"